import CardPage from 'screens/Contract/Card/Card';

export default CardPage;
